import styled from 'styled-components'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'

import { CLICKABLE_COLOR, LINK_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'


export const _SubSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  display: inline-block;
  position: relative;
  font-family: var(--secondary-font);
  line-height: 22px;

  &:nth-child(2) {
    margin-bottom: 20px;
    margin-top: 30px;
  }
`

export const _AmenityIconContainer = styled(NoMarginRow)`
  margin-top: -12px;
  margin-bottom: -8px;
`

export const _ShowMoreCta = styled.button`
  border: none;
  padding: 0;
  display: inline-block;
  margin-top: 16px;
  line-height: 22px;
  font-size: 14px;
  color: ${CLICKABLE_COLOR};
  font-weight: 500;
  @media (hover: hover){
    &:hover{
      color:${LINK_COLOR};
      cursor: pointer;
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

